import http from 'core/services/http';
import Config from 'core/config';
import isObject from 'lodash/isObject';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const toQueryString = (obj) => {
  const params = Object.keys(obj).map(
    (key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
  );
  return params.length ? params.join('&') : '';
};

const userPools = {
  b2b: 'B2B_USERPOOL',
  b2c: 'B2C_USERPOOL',
};

class UsersService {
  static getUsers() {
    return http.get(`${Config.apiUrl}/personnel`);
  }

  static getUserInfo(params) {
    const queryString = isObject(params) ? `?${toQueryString(params)}` : `/${params}`;
    return http.get(`${Config.apiUrl}/personnel${queryString}`);
  }

  static getProfile() {
    return http.get(`${Config.apiUrl}/profile`);
  }

  static getTestCenterEventPersonnel(userId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/testCenterEventPersonnel`);
  }

  static getTestCenterCyclePersonnel(userId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/testCenterCyclePersonnel`);
  }

  static setUserInfo(info) {
    return http.put(`${Config.apiUrl}/personnel`, info);
  }

  static getUserRoles() {
    return http.get(`${Config.apiUrl}/roles`);
  }

  static loginUser(data, userPool) {
    const user = { ...data };
    user.userPool = userPool || userPools.b2b;
    user.appClient = Config.APP_CLIENT;
    return http.post(`${Config.cognitoUrl}/users/login`, user);
  }

  static logoutUser() {
    return http.get(`${Config.cognitoUrl}/users/logout`);
  }

  static createUser(data) {
    const user = { ...data };
    user.appClient = Config.APP_CLIENT;
    return http.post(`${Config.cognitoUrl}/users/register`, user);
  }

  static createPersonnel(info) {
    return http.post(`${Config.apiUrl}/personnel`, info);
  }

  static getAccountTerms(userPool) {
    const pool = userPool || userPools.b2b;
    return http.get(`${Config.cognitoUrl}/config/terms?userPool=${pool}`);
  }

  static getUser(username, userPool) {
    const pool = userPool || userPools.b2b;
    return http.get(`${Config.cognitoUrl}/users/user?username=${username}&userPool=${pool}`);
  }

  static checkUsername(username, userPool) {
    const pool = userPool || userPools.b2b;
    return http.get(`${Config.cognitoUrl}/users/exists?username=${username}&userPool=${pool}`);
  }

  static getSecurityQuestions() {
    return http.get(`${Config.cognitoUrl}/config/securityQuestions`);
  }

  static completeForgotPassword(data) {
    const user = { ...data };
    user.userPool = user.userPool || userPools.b2b;
    return http.post(`${Config.cognitoUrl}/users/completeForgotPassword`, user);
  }

  static verifyUser(data) {
    const user = { ...data };
    user.userPool = user.userPool || userPools.b2b;
    return http.post(`${Config.cognitoUrl}/users/verify`, user);
  }

  static getUserAddress(userId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/address`);
  }

  static forgotPassword(email, userPool) {
    return http.post(`${Config.cognitoUrl}/users/forgotPassword`, {
      username: email,
      userPool: userPool || userPools.b2b,
      appClient: Config.APP_CLIENT,
    });
  }

  static changePassword(data) {
    return http.put(`${Config.cognitoUrl}/users/password`, data);
  }

  static refreshTokens(rToken) {
    const appClient = cookies.get('client');
    return http.post(`${Config.cognitoUrl}/users/refreshTokens`, {
      userPool: userPools.b2b,
      refreshToken: rToken,
      appClient: appClient ? appClient : Config.APP_CLIENT,
    });
  }

  static resendVerification(data) {
    return http.post(`${Config.cognitoUrl}/users/resendVerificationCode`, {
      username: data.username,
      userPool: data.userPool || userPools.b2b,
      appClient: Config.APP_CLIENT,
      option: 'OVERRIDE',
    });
  }
}

export default UsersService;
